module.exports = __webpack_public_path__ + "img/gomb-vizio-aktiv.04ec7ed5.png";